import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';

import { Field } from '../states/settingState';

type Props = {
  open: boolean;
  field?: Field;
  setEditFieldName: (name: string) => void;
  handleCommit: () => void;
  handleClose: () => void;
};

export const FieldUpdateAddFieldDialog: React.FC<Props> = (props) => {

  const onChangeWords = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    props.setEditFieldName(value);
  };

  const handleOk = () => {
    if (props.field) {
      props.handleCommit();
    }
    props.handleClose();
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"分野の名称を指定して分野を追加します"}</DialogTitle>
      <DialogContent>
        <TextField id="words" label="分野名称" value={props.field ? props.field.name : ''} sx={{margin: 2}} onChange={onChangeWords} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary">
          OK
        </Button>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};
